var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true }
        }
      ],
      staticClass: "orderinfo userbox",
      attrs: { id: "orderinfo" }
    },
    [
      _c("div", { staticClass: "userTitle" }, [
        _vm._v(_vm._s(_vm.$t("OrderHistory")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "userOrderTab space_between" },
        [
          _vm.orderCount != null
            ? _c("ul", { staticClass: "AllTab" }, [
                _c(
                  "li",
                  {
                    class: _vm.orderTab == "" ? "on" : "",
                    on: {
                      click: function($event) {
                        return _vm.setTab("")
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("All")) +
                        " (" +
                        _vm._s(_vm.orderCount.All) +
                        ")"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: _vm.orderTab == 1 ? "on" : "",
                    on: {
                      click: function($event) {
                        return _vm.setTab(1)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Unpaid")) +
                        " (" +
                        _vm._s(_vm.orderCount.Unpaid) +
                        ")"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: _vm.orderTab == 2 ? "on" : "",
                    on: {
                      click: function($event) {
                        return _vm.setTab(2)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("ToBeShipped")) +
                        " (" +
                        _vm._s(_vm.orderCount.Shipping) +
                        ")"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: _vm.orderTab == 3 ? "on" : "",
                    on: {
                      click: function($event) {
                        return _vm.setTab(3)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Shipped")) +
                        " (" +
                        _vm._s(_vm.orderCount.Shipped) +
                        ")"
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: _vm.orderTab == 5 ? "on" : "",
                    on: {
                      click: function($event) {
                        return _vm.setTab(5)
                      }
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("Completed")) +
                        " (" +
                        _vm._s(_vm.orderCount.ShippComplete) +
                        ")"
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-input",
            {
              staticClass: "orderSearch",
              attrs: { placeholder: _vm.$t("EnterSearch") },
              model: {
                value: _vm.orderSearch,
                callback: function($$v) {
                  _vm.orderSearch = $$v
                },
                expression: "orderSearch"
              }
            },
            [
              _c("i", {
                staticClass: "searchIcon",
                attrs: { slot: "suffix" },
                slot: "suffix"
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isNull
        ? _c(
            "div",
            [
              _c("div", { staticClass: "order_list order_list_title" }, [
                _c("div", { staticClass: "order_list_products" }, [
                  _vm._v(_vm._s(_vm.$t("Product")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order_list_detail" }, [
                  _vm._v(_vm._s(_vm.$t("Details")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order_list_price" }, [
                  _vm._v(_vm._s(_vm.$t("UnitPrice")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order_list_total" }, [
                  _vm._v(_vm._s(_vm.$t("Total")))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "order_list_operate" }, [
                  _vm._v(_vm._s(_vm.$t("Operate")))
                ])
              ]),
              _vm._v(" "),
              _vm.list != null
                ? _vm._l(_vm.list, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "order_list_border" },
                      [
                        _c("div", { staticClass: "order_list order_list_id" }, [
                          _c("div", { staticClass: "order_list_products" }, [
                            _vm._v(_vm._s(item.CreateDate))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "order_list_detail" }, [
                            _vm._v(
                              _vm._s(_vm.$t("OrderNumber")) +
                                "：" +
                                _vm._s(item.OrderCode)
                            )
                          ]),
                          _vm._v(" "),
                          item.Status == 1 &&
                          item.PayType == 2 &&
                          item.PayCheck == 1
                            ? _c("span", { staticClass: "icon_payOther" }, [
                                _vm._v(_vm._s(_vm.$t("PendingReview")))
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          item.Status == 6
                            ? _c(
                                "span",
                                { staticClass: "icon_payOther close" },
                                [_vm._v(_vm._s(_vm.$t("OrderClosed")))]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm._l(item.OrderDetails, function(res, j) {
                          return _c(
                            "div",
                            {
                              key: j,
                              staticClass: "order_list",
                              class: item.OrderPresale == 1 ? "presale" : ""
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "order_list_products" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "order_img",
                                      attrs: {
                                        to: {
                                          path:
                                            "/market/item/" +
                                            (res.OldCommodityId
                                              ? res.OldCommodityId
                                              : res.CommodityId) +
                                            "?type=1"
                                        }
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src:
                                            res.TitImg + "?imageView2/2/w/160"
                                        }
                                      }),
                                      _vm._v(" "),
                                      item.OrderPresale == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "icon_presale" },
                                            [_vm._v(_vm._s(_vm.$t("PreSale")))]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "order_list_detail" },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          path:
                                            "/market/item/" +
                                            (res.OldCommodityId
                                              ? res.OldCommodityId
                                              : res.CommodityId) +
                                            "?type=1"
                                        }
                                      }
                                    },
                                    [
                                      _c("p", { staticClass: "line_txt3" }, [
                                        _vm._v(_vm._s(res.Title))
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "order_num" }, [
                                    _vm._v(_vm._s(res.Num))
                                  ]),
                                  _vm._v(" "),
                                  item.OrderPresale == 2
                                    ? _c(
                                        "span",
                                        { staticClass: "order_postage" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("Shipping")) +
                                              "：" +
                                              _vm._s(_vm.$t("PayonDelivery"))
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              item.OrderPresale != 2
                                ? _c(
                                    "div",
                                    { staticClass: "order_list_price" },
                                    [
                                      res.LowestPrice != res.Price
                                        ? _c("del", [
                                            _vm._v(
                                              "￥" +
                                                _vm._s(
                                                  res.Price.toLocaleString()
                                                )
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      res.LowestPrice != res.Price
                                        ? _c(
                                            "span",
                                            { staticClass: "price_red" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  res.LowestPrice.toLocaleString()
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      res.LowestPrice == res.Price
                                        ? _c("span", [
                                            _vm._v(
                                              _vm._s(res.Price.toLocaleString())
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.OrderPresale == 2
                                ? _c(
                                    "div",
                                    { staticClass: "order_list_price point" },
                                    [
                                      _c("span", { staticClass: "pointName" }, [
                                        _vm._v(
                                          _vm._s(res.PointsScore) +
                                            " " +
                                            _vm._s(_vm.$t("Points"))
                                        )
                                      ]),
                                      _vm._v(" "),
                                      res.Price > 0
                                        ? _c(
                                            "span",
                                            { staticClass: "priceName" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  res.Price.toLocaleString()
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.OrderPresale != 2
                                ? _c(
                                    "div",
                                    { staticClass: "order_list_total" },
                                    [
                                      j == 0
                                        ? [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  item.RealOrderPrice.toLocaleString()
                                                )
                                              )
                                            ])
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.OrderPresale == 2
                                ? _c(
                                    "div",
                                    { staticClass: "order_list_total point" },
                                    [
                                      j == 0
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "pointName" },
                                              [
                                                _vm._v(
                                                  _vm._s(item.RealPoints) +
                                                    " " +
                                                    _vm._s(_vm.$t("Points"))
                                                )
                                              ]
                                            ),
                                            _c("br"),
                                            _vm._v(" "),
                                            item.RealOrderPrice > 0
                                              ? _c(
                                                  "span",
                                                  { staticClass: "priceName" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.RealOrderPrice.toLocaleString()
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "order_list_operate" },
                                [
                                  j == 0
                                    ? [
                                        item.Status == 1 &&
                                        item.PayType != 2 &&
                                        item.OrderPresale != 1
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.payGo(item)
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(_vm.$t("Pay")))]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.Status == 3
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: { type: "primary" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setOrder(
                                                      "确认收货",
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("ConfirmDelivery")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.PayType == 2 && item.PayType != 3
                                          ? _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.payOrder(
                                                      "payOrder",
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("ViewReceipt"))
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.PayType != 2 &&
                                        item.PaymentPayType == 2 &&
                                        item.PayType != 3
                                          ? _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.payOrder(
                                                      "payOrder",
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$t("ViewReceipt"))
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.Status == 1 && !item.IsPay
                                          ? _c(
                                              "span",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setOrderAddress(
                                                      "setOrderAddress",
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("UpdateAddress")
                                                  )
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "router-link",
                                          {
                                            attrs: {
                                              to: {
                                                path:
                                                  "/order/detail/" + item._id
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(_vm.$t("ViewDetails")) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      ]
                                    : _vm._e()
                                ],
                                2
                              ),
                              _vm._v(" "),
                              item.OrderPresale == 1 && item.Status != 6
                                ? _c("ul", { staticClass: "presaleList" }, [
                                    _c("li", [
                                      _c(
                                        "div",
                                        { staticClass: "order_list_detail" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "line_txt3" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Stage1")) +
                                                  "：" +
                                                  _vm._s(_vm.$t("Deposit"))
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "order_list_price" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .priceCount(
                                                    item.AdvancePrice,
                                                    res.Num,
                                                    "div"
                                                  )
                                                  .toLocaleString()
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "order_list_total" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                item.AdvancePrice.toLocaleString()
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "order_list_operate" },
                                        [
                                          !item.IsPayDeposit
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    disabled:
                                                      item.PayCheck == 1 &&
                                                      item.PayType == 2
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.payGo(item)
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(_vm.$t("Pay")))]
                                              )
                                            : _c("span", {
                                                staticClass: "yesRpg"
                                              })
                                        ],
                                        1
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("li", [
                                      _c(
                                        "div",
                                        { staticClass: "order_list_detail" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "line_txt3" },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Stage2")) +
                                                  "：" +
                                                  _vm._s(_vm.$t("Balance"))
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "order_list_price" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .priceCount(
                                                    _vm.priceCount(
                                                      item.RealOrderPrice,
                                                      item.AdvancePrice,
                                                      "sub"
                                                    ),
                                                    res.Num,
                                                    "div"
                                                  )
                                                  .toLocaleString()
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "order_list_total" },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm
                                                  .priceCount(
                                                    item.RealOrderPrice,
                                                    item.AdvancePrice,
                                                    "sub"
                                                  )
                                                  .toLocaleString()
                                              )
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "order_list_operate" },
                                        [
                                          item.IsPayDeposit && item.Status < 2
                                            ? _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    disabled: _vm.isPay(item)
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.payGo(item)
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(_vm.$t("Pay")))]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          item.Status > 1
                                            ? _c("span", {
                                                staticClass: "yesRpg"
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]
                          )
                        })
                      ],
                      2
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("pagination", {
                attrs: { TotalCount: _vm.TotalCount, ps: _vm.ps },
                on: { ps: _vm.pageSize, pi: _vm.pageIndex }
              }),
              _vm._v(" "),
              _vm.dislogType.address
                ? _c("to-address", {
                    attrs: {
                      title: _vm.title,
                      domVisible: _vm.dislogType.address,
                      list: _vm.addressItem,
                      isSet: _vm.isSet
                    },
                    on: { closeDialog: _vm.closeDialog }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.dislogType.setOrderAddress
                ? _c("set-address", {
                    attrs: {
                      title: _vm.$t("SelectAddress"),
                      domVisible: _vm.dislogType.setOrderAddress,
                      infoList: _vm.addressInfo
                    },
                    on: {
                      closeDialog: _vm.closeDialog,
                      setAddress: _vm.setAddress
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.dislogType.payOrder
                ? _c("pay-order", {
                    attrs: {
                      title: _vm.$t("PaymentReceipt"),
                      domVisible: _vm.dislogType.payOrder,
                      infoList: _vm.payOrderItem
                    },
                    on: { closeDialog: _vm.closeDialog }
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isNull
        ? _c("nonull", {
            attrs: { type: "order", text: _vm.$t("NoOrdersFound") }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0edb4ee4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0edb4ee4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/order.vue
// module id = null
// module chunks = 